import React from 'react';
import { useField } from 'formik';

export interface Option {
    value: string;
    label: string;
}

interface ElogSelectProps {
    label: string;
    name: string;
    options: Option[];
    mandatory?: boolean;
    onChange?: (selectedValue: string) => void;
    value?: string; // Optional prop to set the initial value
}

const ElogSelect: React.FC<ElogSelectProps> = ({
                                                   label,
                                                   name,
                                                   options,
                                                   mandatory = false,
                                                   onChange,
                                                   value,
                                               }) => {
    const [field] = useField({ name, value });

    const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedValue = e.target.value;
        if (onChange) {
            onChange(selectedValue);
        }
        field.onChange(e);
    };

    return (
        <tr>
            <th>
                {mandatory && <span>*</span>}
                {label}:
            </th>
            <td>
                <select
                    {...field}
                    className="text"
                    onChange={handleSelectChange}
                >
                    {options.map((option) => (
                        <option key={name + option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </td>
        </tr>
    );
};

export default ElogSelect;